import { AUTHORIZATION } from "../../../../constants/api/auth";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { MemberDeleteDocumentPayload } from "../../../../types/memberDeleteDocumentPayload.types";

const { Authorization, Bearer } = AUTHORIZATION;
const { post, get, del } = request;
const initialRoute = "member";

export const memberDocumentUpload = async (_formData: FormData) => {
	try {
		const endpoint = `${initialRoute}/document`;
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, _formData, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const getMemberUploadedFile = async (ssn: string, group_number: number) => {
	try {
		const endpoint = `${initialRoute}/get-uploaded-document/${ssn}/${group_number}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const getFolderDocumentList = async (filter: any) => {
	try {
		const endpoint = `${initialRoute}/get-folder-document/`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const getGroupOwnerSharedDocument = async (member_object_id: string) => {
	try {
		const endpoint = `${initialRoute}/get-shared-document/${member_object_id}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const deleteMemberUploadedFile = async (payload: MemberDeleteDocumentPayload) => {
	try {
		const { ssn, group_number, member_document_object_id, document_object_id } = payload;
		const endpoint = `${initialRoute}/delete-document?ssn=${ssn}&group_number=${group_number}&member_document_object_id=${member_document_object_id}&document_object_id=${document_object_id}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await del(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			// console.log("response status", response);
			if (message === MESSAGE.delete.succ) {
				return response.data.result;
			}
		}
		throw new Error();
	} catch (error) {
		// console.log("error", error);
		throw error;
	}
};
